<ul class="nav nav-link-tabs justify-content-start" id="navcontainer">
	<li class="nav-item" *ngFor="let widget of widgets; let i = index">
		<a (click)="openTab($event)" class="nav-link" role="tab" id="{{ tempWidget[i] | lowercase }}-tab">
			<h4>{{ widget }}</h4>
		</a>
	</li>
</ul>
